/* eslint-disable indent */
import { buildNtbCards as buildNtbCardItems } from '~/modules/retailMedia/helpers/ntbCards'
import {
  buildNtbTooltipValues,
  getNtbBadgeLabel
} from '~/modules/retailMedia/helpers/ntbMetrics'

type BuildCardItemProps<TypesCards> = {
  enabled?: boolean
  id: string
  label: string
  title: string | number | JSX.Element
  value: string | number | JSX.Element
  compareValue?: string | number | JSX.Element | null
  type: TypesCards
  loading?: boolean
  isRelativeInterval?: boolean
}

export const buildCompareValue = (
  isCompare?: boolean,
  compareValue?: string | number | JSX.Element | null
) => (isCompare ? compareValue : null)

export const buildCardItem = <TypesCards,>({
  enabled = true,
  id,
  label,
  title,
  value,
  compareValue,
  type,
  loading = false,
  isRelativeInterval
}: BuildCardItemProps<TypesCards>): CardItem<TypesCards>[] =>
  enabled
    ? [
        {
          id,
          label,
          title,
          value,
          compareValue,
          type,
          loading,
          isRelativeInterval
        }
      ]
    : []

/**
 * Os 4 cards de NTB são idênticos nas três telas do dashboard (advertiser,
 * publisher e publisher list-all); a métrica ausente vira traço.
 */
export const buildNtbCards = ({
  data,
  compareData,
  isCompare,
  loading,
  availableMetrics,
  lookbackMonths,
  ntbOrdersWindow
}: BuildNtbCardsProps): CardItem<TypesNtbCard>[] =>
  buildNtbCardItems({
    availableMetrics,
    formatted: data?.formatted,
    compareFormatted: compareData?.formatted,
    tooltipValues: buildNtbTooltipValues({
      lookbackMonths,
      ordersWindow: ntbOrdersWindow
    }),
    badge: getNtbBadgeLabel(ntbOrdersWindow),
    typeOf: metric => metric.rawKey
  }).map(card => ({
    ...card,
    loading: !!loading,
    compareValue: buildCompareValue(isCompare, card.compareValue)
  }))
